var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIntelligenceReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 31
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Intelligence Report"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 4366",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.193 23.33a1.25 1.25 0 01-1.25-1.25v-4.609A8.5 8.5 0 011.5 10 8.5 8.5 0 0110 1.5a8.5 8.5 0 018.5 8.5 8.5 8.5 0 01-4.443 7.472v4.608a1.251 1.251 0 01-1.25 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.807 23.33c.69 0 1.25-.56 1.25-1.25V17.47A8.499 8.499 0 0018.5 10 8.5 8.5 0 0010 1.5a8.5 8.5 0 00-4.057 15.97v4.61c0 .69.559 1.25 1.25 1.25h5.614m0 1.5H7.193a2.754 2.754 0 01-2.75-2.75v-3.765A10 10 0 010 9.999C0 4.486 4.486 0 10 0s10 4.486 10 10a10 10 0 01-4.443 8.315v3.764a2.753 2.753 0 01-2.75 2.75z",
    fill: "#00b8f1"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4368",
    d: "M6.5 26.1h7",
    fill: "none",
    stroke: "#00b8f1",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4369",
    d: "M6.5 28.1h7",
    fill: "none",
    stroke: "#00b8f1",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2173"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4367",
    d: "M9 31a2 2 0 01-1.97-1.65h5.938A2 2 0 0111 31z",
    fill: "#00b8f1"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 4365",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.761 4.778a.25.25 0 01.478 0l1 3.255a.25.25 0 00.239.177l3.278-.01a.25.25 0 01.152.449l-2.677 2.04a.25.25 0 00-.087.273l1.022 3.286a.25.25 0 01-.391.273l-2.623-2.012a.25.25 0 00-.3 0l-2.626 2.012a.25.25 0 01-.391-.273l1.022-3.286a.25.25 0 00-.087-.273L5.092 8.652a.25.25 0 01.152-.452l3.278.007a.25.25 0 00.239-.177z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.602a.245.245 0 00-.239.176l-1 3.255a.25.25 0 01-.238.177l-3.28-.007a.25.25 0 00-.151.45l2.677 2.036a.25.25 0 01.088.273l-1.022 3.286a.25.25 0 00.24.326c.05 0 .103-.017.15-.053l2.623-2.012a.25.25 0 01.304 0l2.622 2.012c.048.036.1.053.151.053a.25.25 0 00.24-.326l-1.022-3.286a.25.25 0 01.088-.273l2.677-2.037a.25.25 0 00-.152-.449l-3.278.007a.25.25 0 01-.24-.177l-.999-3.255A.245.245 0 0010 4.602m0-1.5c.774 0 1.446.497 1.673 1.236l.727 2.37 2.353-.005a1.75 1.75 0 011.063 3.143l-1.98 1.507.762 2.45c.164.53.067 1.11-.26 1.555-.33.448-.858.716-1.413.716-.386 0-.754-.126-1.063-.363L10 14.283l-1.862 1.428c-.309.237-.677.363-1.063.363a1.761 1.761 0 01-1.413-.716 1.754 1.754 0 01-.26-1.555l.762-2.45-1.98-1.507a1.749 1.749 0 011.06-3.143l2.356.005.727-2.37c.227-.74.9-1.236 1.673-1.236z",
    fill: "#fff"
  })))));
}

export default SvgIconIntelligenceReports;